import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import Table from '../../../components/NotesPage/Table';
import { getSortedByDateIds } from '../selectors';

const mapStateToProps = (state: StoreState) => {
	return {
		allIds: getSortedByDateIds(state),
	};
};

export default connect(mapStateToProps)(Table);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotesPage/Table/index.tsx